import {
    PostsState,
    PostActionTypes,

    FETCH_POST_STARTED,
    FETCH_POST_ERROR,
    FETCH_POST_SUCCESS,
    POST_POST,
    PUT_POST
  } from "./types";
import { clone } from "../categories/functions";
import { finder } from "./functions";

const initialState: PostsState = {
    posts: [],
    isFetching: false,
    error: {}
};

export function postsReducer(
    state=initialState,
    action: PostActionTypes
):PostsState {
    let postIndex = -1;
    let tempState: PostsState;
    switch(action.type){
        case FETCH_POST_STARTED:
            return Object.assign({}, state, {
                isFetching: true
            })
        case FETCH_POST_ERROR:
            return Object.assign({}, state, {
                error: action.error
            })
        case FETCH_POST_SUCCESS:
            postIndex = finder(action.post.id,state.posts);
            tempState = clone(state);

            if(postIndex != -1) {
                tempState.posts[postIndex] = action.post;
            } else {
                tempState.posts.push(action.post);
            }

            tempState.isFetching = false;
            return tempState;
        case POST_POST:
        case PUT_POST:
            postIndex = finder(action.id,state.posts);
            tempState = clone(state);
            if(postIndex != -1) {
                tempState.posts.splice(postIndex,1);
            }
            tempState.isFetching = false;
            return tempState;
        default:
            return state;
    }

} 